import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { External } from '../../Link';
import { makeStyles } from '@material-ui/core/styles';
import { Headline, Paragraph } from './index';

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
}));
const MoreGoogleAds = () => {
  const classes = useStyles();
  return (
    <Box mt={4}>
      <Headline>
        Servicebeschreibung
      </Headline>
      <Paragraph>
        Dies ist ein Conversion-Marketing-Service. Dies bedeutet, dass Websites dabei helfen, Website-Besucher zu zahlenden Kunden zu machen.
      </Paragraph>
      <Headline>
        Verarbeitendes Unternehmen
      </Headline>
      <Paragraph>
        Google Ireland Limited <br />
        Google Building Gordon House, 4 Barrow St,
        Dublin, D04 E5W5, Ireland
      </Paragraph>
      <Headline>
        Datenverarbeitungszwecke
      </Headline>
      <Paragraph>
        Diese Liste stellt die Zwecke der Datenerhebung und -verarbeitung dar.{' '}
        <br />
        - Werbung, Conversion-Tracking
      </Paragraph>
      <Headline>
        Verwendete Technologien
      </Headline>
      <Paragraph>
        Diese Liste enthält alle Technologien, mit denen dieser Dienst Daten
        sammelt. Typische Technologien sind Cookies und Pixel, die im Browser
        platziert werden. <br />
        - Cookies
      </Paragraph>
      <Headline>
        Erhobene Daten
      </Headline>
      <Paragraph>
        Diese Liste enthält alle (persönlichen) Daten, die von oder durch die Nutzung dieses Dienstes gesammelt werden. <br/>
        - IP-Adresse, Browsertyp, Datum und Uhrzeit des Besuchs, Browsersprache, Webanfrage, Cookie-ID
      </Paragraph>
      <Headline>
        Rechtliche Grundlage
      </Headline>
      <Paragraph>
        Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung
        von Daten genannt.
        <br />
        - Art. 6 (1) (a) GDPR
      </Paragraph>
      <Headline>
        Ort der Verarbeitung
      </Headline>
      <Paragraph>
        Dies ist der primäre Ort, an dem die gesammelten Daten verarbeitet
        werden. Sollten die Daten auch in anderen Ländern verarbeitet werden,
        werden Sie gesondert informiert. <br />
        - Europäische Union
      </Paragraph>
      <Headline>
        Aufbewahrungsdauer
      </Headline>
      <Paragraph>
        Die Aufbewahrungsfrist ist die Zeitspanne, in der die gesammelten Daten
        für die Verarbeitung gespeichert werden. Die Daten müssen gelöscht
        werden, sobald sie für die angegebenen Verarbeitungszwecke nicht mehr
        benötigt werden.
	<br />- Die Daten werden gelöscht, sobald sie nicht mehr für die
        Verarbeitungszwecke benötigt werden.
      </Paragraph>
      <Paragraph>
        <External
          target="_blank"
          className={classes.link}
          href="https://policies.google.com/privacy?hl=en"
        >
          Klicken Sie hier
        </External>
        , um die Datenschutzbestimmungen des Datenverarbeiters zu lesen. <br />
        <External
          target="_blank"
          className={classes.link}
          href="https://policies.google.com/technologies/cookies?hl=en"
        >
          Klicken Sie hier
        </External>
        , um die Cookie-Richtlinie des Datenverarbeiters zu lesen. <br />
        <External
          target="_blank"
          className={classes.link}
          href="https://safety.google/privacy/privacy-controls/"
        >
          Klicken Sie hier
        </External>
        , um auf allen Domains des verarbeitenden Unternehmens zu widerrufen.
      </Paragraph>
    </Box>
  );
};

export default MoreGoogleAds;
